import { Flex, Skeleton } from '@/components';
import { LineChartOutlined } from '@ant-design/icons';
import type { FC } from 'react';

export const AnalysisResultsSkeletonContents: FC = () => {
  return (
    <Flex
      gap="4px 0"
      wrap="wrap"
      vertical
      style={{
        marginTop: 16,
      }}
    >
      <Skeleton.Input active size="small" />
      <Skeleton.Input active />
      <Skeleton.Node
        active
        style={{
          width: '100%',
          height: 400,
          marginTop: 16,
        }}
      >
        <LineChartOutlined
          style={{
            fontSize: 120,
            opacity: 0.1,
          }}
        />
      </Skeleton.Node>
    </Flex>
  );
};
